import * as ATypes from '../../shared/actionTypes';

export const setDeeplinkData = ({
  action = null,
  payload_code = null,
  authority = null,
  country = null,
  meta = {},
  needsDeeplinkRedirection = false,
} = {}) => ({
  type: ATypes.SET_DEEPLINK_DATA,
  payload: {
    action,
    payload_code,
    authority,
    country,
    meta,
    needsDeeplinkRedirection,
  },
});

export const clearDeeplinkData = () => ({
  type: ATypes.CLEAR_DEEPLINK_DATA,
});
